import * as angular from 'angular';
import * as _ from 'lodash';
import AdminChangePasswordName, {openAdminChangePassword} from "./changePassword.controller";
import EditUserName, {openEditUser} from "./editUser.controller";
import {States} from "../../shared/config/constant.module";
import template from './users.tpl.html';
import UserServiceName, {UserService} from "../../services/users/user.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {Plant} from "../../models/navigation";

let requires = [AdminChangePasswordName, EditUserName, UserServiceName, AuthDataServiceName, NavigationServiceName,
  LoaderServiceName];

interface UsersController {
  role: apsViewModels.RoleListItem;
  roles: apsViewModels.RoleListItem[];
  plant: Plant;
  plants: Plant[];
  users: apsViewModels.UserListItem[];
  isAdmin: boolean;
  showDeleted: boolean;
  orderBy: string;
  permissions: string;

  refresh(): void;
  addUser(): void;
  editUser(user: apsViewModels.UserListItem): void;
  changePassword(user: apsViewModels.UserListItem): void;
}

export default angular.module('aps.controller.users', requires)
  .config(function($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.USERS,
      url: '/admin/users',
      controller: 'UsersCtrl as usersCtrl',
      template: template,
      data: {
        pageTitle: 'Users',
        authorizePlantAdmin: true
      }
    });
  })
  .controller('UsersCtrl', usersCtrl)
  .name;

function usersCtrl(
  userService: UserService,
  authDataService: AuthDataService,
  navigationService: NavigationService,
  loaderService: LoaderService,
  $modal: mm.foundation.modal
) {
  let vm = this as UsersController;
  vm.permissions = '';
  vm.orderBy = 'userName';
  vm.showDeleted = false;

  vm.isAdmin = authDataService.isAdmin();

  vm.refresh = function() {
    if (!vm.isAdmin && !vm.plant) {
      return;
    }
    loaderService.loadingPromise(
      userService.getUsers( (vm.plant ? vm.plant.id : null), (vm.role ? vm.role.id : null), vm.showDeleted)
        .then(users => {
          vm.users = _.filter(users, (u) =>
            !u.isSystemUser && (vm.isAdmin || u.plant === vm.plant.name)
          );

          if (vm.permissions) {
            vm.users = _.filter(vm.users, (u) =>
              vm.permissions === 'sysadmin' && u.isSysAdmin || _.includes(u.plantAdmins, vm.permissions));
          }
        }));
  };
  vm.refresh();

  let securityQuestions;
  userService.getSecurityQuestions()
    .then(questions => {
      securityQuestions = questions;
    });

  userService.getAssignableRoles()
    .then(data => {
      vm.roles = data;
    });

  navigationService.getNavigation()
    .then(navigation => {
      let plants = navigation.plants();
      vm.plants = _.filter(plants, (plant: any) => {
        return authDataService.isPlantAdmin(plant.id);
      });
      if (!vm.isAdmin) {
        vm.plant = _.first(vm.plants);
        vm.refresh();
      }
    });

  let openEditDialog = function(user) {
    let result = openEditUser({
      id: user ? user.id : undefined,
      questions: securityQuestions,
      roles: vm.roles,
      plants: vm.plants
    }, $modal);

    result.then(function(editedUser: any) {
      if (editedUser) {
        switch (editedUser.roles.length) {
          case 0:
            editedUser.role = 'None';
            break;
           case 1:
             editedUser.role = editedUser.roles[0].roleName;
             break;
           default:
             editedUser.role = 'Multiple';
             break;
        }

        let plants = _.uniq(_.map(_.flatten(_.map(editedUser.roles, 'plants')), 'name'));
        switch (plants.length) {
          case 0:
            editedUser.plant = 'None';
            break;
           case 1:
             editedUser.plant = plants[0];
             break;
           default:
             editedUser.plant = 'Multiple';
             break;
        }

        if (user) {
          if (editedUser.isDeleted && !vm.showDeleted) {
            _.remove(vm.users, user);
            return;
          }
          _.assign(user, editedUser);
          return;
        }
        vm.users.push(editedUser);
      }
    });
  };

  vm.addUser = function() {
    openEditDialog(undefined);
  };

  vm.editUser = function(user) {
    openEditDialog(user);
  };

  vm.changePassword = function(user) {
    openAdminChangePassword(user, $modal);
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/users.controller.ts